module.exports = __webpack_public_path__ + "img/ics_o_chevron_left.ae74df55.svg";